import responseHandler from "../system/server-response-handler";
import { getRequest, postRequest } from "../system/server-calls";

const COMMON_URL = "CountriesEncyclopedia";

// Fetch a list of countries for the encyclopedia
const getAllCountriesEncyclopedia = (payload) => {
  return postRequest(`${COMMON_URL}`, payload).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Fetch detailed information about a specific country
const getCountryEncyclopediaDetailById = (id) => {
  return getRequest(`${COMMON_URL}/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const countriesEncyclopediaService = {
  getAllCountriesEncyclopedia,
  getCountryEncyclopediaDetailById,
};
